import { render, staticRenderFns } from "./DocumentProvider.vue?vue&type=template&id=4bdeaf53"
import script from "./DocumentProvider.vue?vue&type=script&lang=ts"
export * from "./DocumentProvider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bdeaf53')) {
      api.createRecord('4bdeaf53', component.options)
    } else {
      api.reload('4bdeaf53', component.options)
    }
    module.hot.accept("./DocumentProvider.vue?vue&type=template&id=4bdeaf53", function () {
      api.rerender('4bdeaf53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/DocumentProvider.vue"
export default component.exports